<template>
  <v-container fluid align-start ma-0 pa-2 class="epmsa310-main container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" :useBtnList="useBtnList"
          @btnRetrieve="btnRetrieve"
          @btnSaveAsExcel="btnSaveAsExcel">
          <template v-slot:body>
            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="[]"
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2">
                      <v-col cols="9">
                        <v-row no-gutters>
                          <i-label :label="'Year :'" />
                          <v-col cols="1">
                            <v-select
                              v-model="selectYear"
                              :items="yearList"
                              single-line
                              outlined
                              dense
                              height="32" />
                          </v-col>

                          <i-label :label="'Month :'" class="pl-2" />
                          <v-col cols="1">
                            <v-select
                              v-model="selectMonth"
                              :items="monthList"
                              single-line
                              outlined
                              dense
                              height="32" />
                          </v-col>

                          <i-label :label="'Times :'" class="pl-2" />
                          <v-col cols="1">
                            <v-select
                              v-model="selectTimes"
                              :items="timesList"
                              single-line
                              outlined
                              dense
                              height="32" />
                          </v-col>

                          <i-label :label="'Cutting Div :'" class="pl-2" />
                          <v-col cols="2">
                            <v-select
                              v-model="selectCutDiv"
                              :items="cutDivList"
                              return-object
                              item-text="codeName"
                              item-value="code"
                              single-line
                              outlined
                              dense
                              height="32" />
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col cols="3">
                        <v-row no-gutters class="justify-end">
                          <i-label :label="'Invoice No :'" class="pl-2" />
                          <v-col cols="6" class="d-flex">
                            <v-text-field
                              class="pr-2"
                              v-model="invoiceNo" 
                              dense 
                              outlined 
                              hide-details="auto"
                              height="32"
                            />
                          <i-button :text="'Close'" :isCustom="true" class="btn-close" @click="btnClose" />
                        </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters class="pt-1">
              <v-col>
                <DxDataGrid
                  class="listBox"
                  :ref="epmsa310Ref"
                  :data-source="dataList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="id" 
                  :focused-row-enabled="true"
                  :column-hiding-enabled="false" 
                  :sorting="{ mode: 'none' }"
                  :selection="{ mode: 'none' }"
                  @cellPrepared="cellPrepared"
                >
                  <DxPaging :enabled="false" />
                  <DxPager :visible="false" />

                  <DxColumn data-field="shipNo" caption="Ship No" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="lotNo" caption="Lot" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="cutGrp" caption="Cutting Group" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="pcsSumQty" caption="Qty" alignment="right" :allow-editing="false" data-type="number" :format="format" />
                  <DxColumn data-field="pcsSumWgt" caption="Weight(kg)" alignment="right" :allow-editing="false" data-type="number" :format="format" />
                  <DxColumn data-field="cutFeeFor" caption="Amount(WON)" alignment="right" :allow-editing="false" data-type="number" :format="format" />
                  <DxColumn data-field="cutFeeUsd" caption="Amoun(USD)" alignment="right" :allow-editing="false" data-type="number" :format="format" />
                  <DxColumn data-field="cutFeeVnd" caption="Amount(VND)" alignment="right" :allow-editing="false" data-type="number" :format="format" />
                  <DxColumn data-field="cutFeeVat" caption="V.A.T" alignment="right" :allow-editing="false" data-type="number" :format="format" />
                  <DxColumn data-field="cutNo" caption="Cutting Order No" alignment="center" :allow-editing="false" width="20%" />

                  <DxSummary :calculate-custom-summary="cutNoTotal">
                    <DxTotalItem column="shipNo" summary-type="count" display-format="TOTAL" />
                    <DxTotalItem column="pcsSumQty" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="pcsSumWgt" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="cutFeeFor" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="cutFeeUsd" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="cutFeeVnd" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="cutFeeVat" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem show-in-column="cutNo" summary-type="custom" name="cutNoTotal" />
                  </DxSummary>
                </DxDataGrid>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import iButton from '@/components/common/iButton'
import notify from 'devextreme/ui/notify'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getCurrentDate, getNumComma } from '@/utils/common.js'
import { epmsa310, epmsa310Xls, epmsa310Close } from '@/api/view/hip/A/epmsa310'

export default {
  name: 'epmsa310',
  mixins: [baseview, BaseDataGrid],
  components: {
    iButton
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      makerCd: this.$store.state.user.makerCd,
      userId: this.$store.state.user.userId,
      format: '#,##0.##',
      //totalformat: '#,##0.##',
      epmsa310Ref: 'epmsa310Ref',
      useBtnList: ['btnRetrieve', 'btnSaveAsExcel'],
      selectYear: '',
      yearList: [],
      selectMonth: '',
      monthList: [],
      selectTimes: '',
      timesList: [],
      selectCutDiv: null,
      cutDivList: [],
      invoiceNo: '',
      dataList: []
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epmsa310Ref)
    }
  },
  methods: {
    test(e) {
      console.log('ee', e)
    },
    async init() {
      this.gridInstance.option('defaultPaging', false)

      this.getYMT()
      await this.getCutDiv()
    },
    getYMT() {
      const now = getCurrentDate().split('-')

      this.yearList = ['2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028']
      this.selectYear = now[0]

      this.monthList = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
      this.selectMonth = now[1]

      this.timesList = ['1', '2', '3']
      if(Number(now[2]) <= 10) {
        this.selectTimes = '1'
      } else if(Number(now[2]) <= 20) {
        this.selectTimes = '2'
      } else if(Number(now[2]) <= 31) {
        this.selectTimes = '3'
      }
    },
    async getCutDiv() {
      await getCmChildCode({
        code: '',
        codegr: '',
        prtCode: 'CUT_DIV',
        userFlag: 'Y'
      }).then(res => {
        this.cutDivList = res.list
        this.selectCutDiv = this.cutDivList[0]
      })
    },
    btnRetrieve() {
      let edDte = ''

      if(this.selectTimes === '1') {
        edDte = this.selectYear + this.selectMonth + '10'
      } else if(this.selectTimes === '2') {
        edDte = this.selectYear + this.selectMonth + '20'
      } else if(this.selectTimes === '3') {
        if(this.selectMonth ==='02') {
          edDte = this.selectYear + this.selectMonth + '29'
        }else if(this.selectMonth ==='04' || this.selectMonth ==='06' || this.selectMonth ==='09' || this.selectMonth === '11') {
          edDte = this.selectYear + this.selectMonth + '30'
        }else{
          edDte = this.selectYear + this.selectMonth + '31'
        }
      }

      const param = {
        makerCd: this.makerCd,
        cutDiv: this.selectCutDiv.code,
        edDte: edDte
      }

      console.log('epmsa310 Param', param)

      this.openLoading()
      epmsa310(param).then(res => {
        // console.log('epmsa310 Res', res)

        let data = res.list
        for(let i = 0; i < data.length; i++) {
          data[i].id = i
        }
        this.dataList = data
      }).finally(() => {
        this.endLoading()
      })
    },
    btnSaveAsExcel() {
      let edDte = ''

      if(this.selectTimes === '1') {
        edDte = this.selectYear + this.selectMonth + '10'
      } else if(this.selectTimes === '2') {
        edDte = this.selectYear + this.selectMonth + '20'
      } else if(this.selectTimes === '3') {
        if(this.selectMonth ==='02') {
          edDte = this.selectYear + this.selectMonth + '29'
        }else if(this.selectMonth ==='04' || this.selectMonth ==='06' || this.selectMonth ==='09' || this.selectMonth === '11') {
          edDte = this.selectYear + this.selectMonth + '30'
        }else{
          edDte = this.selectYear + this.selectMonth + '31'
        }
      }
      const param = {
        makerCd: this.makerCd,
        cutDiv: this.selectCutDiv.code,
        edDte: edDte,
        closeYear: this.selectYear,
        closeMonth: this.selectMonth,
        closeTimes: this.selectTimes
      }

      this.openLoading()
      epmsa310Xls(param).finally(() => {
        this.endLoading()
      })
    },
    btnClose() {
      if(this.dataList.length < 1) {
        this.vToastify(this.$t('Data is not found.'), 'warn')
        return
      }

      if(!this.invoiceNo) {
        this.vToastify(this.$t('Input invoice no.'), 'warn')
        return
      }

      this.vToastifyPrompt(
        this.$t('Do you want to closing?'),
        'info',
        async current => {
          this.openLoading()

          const param = {
            closeYear: this.selectYear,
            closeMonth: this.selectMonth,
            closeTimes: this.selectTimes,
            makerCd: this.makerCd,
            invoiceNo: this.invoiceNo,
            cutDiv: this.selectCutDiv.code,
            userId: this.userId
          }

          epmsa310Close(param).then(async res => {
            // console.log('btnDeleteRes', res)

            const msg = res.body
            if(msg === 'OK') {
              notify(this.$t('Closing is completed.'), 'success', 3000)
              this.btnRetrieve()
            } else {
              this.vToastify(this.$t(`An error has been occured.<br>${msg}`), 'warn')
              return
            }
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        false
      )
    },
    totalFormat(e) {
      const result = this.getNumComma(e.value.toFixed(2))
      return result
    },
    getNumComma(val) {
      return getNumComma(Number(val))
    },
    cutNoTotal(e) {
      if(e.name === 'cutNoTotal') {
        // console.log('e', e.value)

        if(this.dataList.length > 0) {
          switch(e.summaryProcess) {
            case 'start':
              e.totalValue = ''
              break
            case 'calculate':
                e.unitPrice = e.value.unitPrice
                e.moneUnit = e.value.moneUnit
                e.forRate = e.value.forRate
                e.usdRate = e.value.usdRate
                break
            case 'finalize':
                e.totalValue =
                  `Price : ${this.getNumComma(e.unitPrice)} ${e.moneUnit} / TON`
                  + `\nExchange Rate(1$) : ${this.getNumComma(e.forRate)} WON, ${this.getNumComma(e.usdRate)} VND`
                break
          }
        }
      }
    },
    cellPrepared(e) {
      if(e.rowType === 'totalFooter') {
        if(e.column.dataField === 'shipNo') {
          e.cellElement.setAttribute('colspan', 3)
        } else if(e.column.dataField === 'lotNo' || e.column.dataField === 'cutGrp') {
          e.cellElement.style.display = 'none'
        } else if(e.column.dataField === 'cutNo') {
          e.cellElement.style['white-space'] = 'pre'
          e.cellElement.querySelector('div').style.textAlign = 'left'
        }

        if(e.cellElement.getElementsByClassName('dx-datagrid-summary-item dx-datagrid-text-content')[0]) {
          e.cellElement.getElementsByClassName('dx-datagrid-summary-item dx-datagrid-text-content')[0].style.color = '#000000'
          // e.cellElement.getElementsByClassName('dx-datagrid-summary-item dx-datagrid-text-content')[0].style.fontWeight = 'bold'
        }
      }
    },
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.epmsa310-main {
  ::v-deep {
    .btn-close {
      .v-btn__content {
        div, i {
          color: #ff0000 !important;
        }
      }
    }
  }
}
</style>